
const tiers = [
  {
    label: "Immigration",
    status: "NOW",
    statusColor: "text-green-500",
    dotColor: "bg-green-500",
    description: "£24.4B global. Xeni live. Roll-up ready.",
  },
  {
    label: "Legal",
    status: "NEXT",
    statusColor: "text-orange-500",
    dotColor: "bg-orange-500",
    description: "£1.1T global. Same playbook: acquire, deploy, transform.",
  },
  {
    label: "All Regulated",
    status: "SCALE",
    statusColor: "text-[#818cf8]",
    dotColor: "bg-[#818cf8]",
    description: "£3T+. Each vertical adds new agent skills to the COSX engine.",
  },
];

export function V2BiggerPictureSlide({ isActive: _ }: { isActive: boolean }) {
  return (
    <div className="flex flex-col h-full">
      <div className="mb-3 max-w-3xl">
        <h2 className="text-[32px] font-light tracking-tight mb-2 font-[family-name:var(--font-heading)]">
          Immigration is the beachhead
        </h2>
        <p className="text-[14px] leading-relaxed text-[var(--color-fg-secondary)] font-light">
          The same AI roll-up playbook applies across every regulated professional service.<br />
          Immigration proves the model. Then we expand.
        </p>
      </div>

      <div className="flex flex-row gap-6 mb-2">
        {/* Left: tier list */}
        <div className="flex-1 pl-5 pt-6">
          <div className="flex flex-col gap-5">
            {tiers.map((t, i) => (
              <div key={t.label} className="relative">
                <div className={`absolute left-[-17px] top-[4px] w-2.5 h-2.5 rounded-full shrink-0 z-[1] ${t.dotColor}`} />
                {i < tiers.length - 1 && <div className="absolute left-[-13px] top-[14px] bottom-[-24px] w-px bg-[var(--color-border)]" />}
                <h3 className="text-[12px] font-[family-name:var(--font-mono)] font-bold uppercase tracking-[0.1em] mb-1.5">
                  <span className="text-[var(--color-fg)]">{t.label}</span> — <span className={t.statusColor}>{t.status}</span>
                </h3>
                <p className="text-[12px] text-[var(--color-fg-secondary)] leading-snug">{t.description}</p>
              </div>
            ))}
          </div>
        </div>

        {/* Right: concentric circles visualization */}
        <div className="w-[38%] flex flex-col items-center justify-start relative -mt-14">
          <div className="relative" style={{ width: 340, height: 340 }}>
            <div
              className="absolute bottom-0 left-1/2 -translate-x-1/2 rounded-full flex flex-col items-center pt-[12%]"
              style={{ width: 340, height: 340, background: "rgba(165, 180, 252, 0.4)" }}
            >
              <span className="text-[11px] opacity-90 mb-1 text-white">Regulated Services</span>
              <span className="text-[24px] font-medium text-white font-[family-name:var(--font-heading)]">£3T+</span>
            </div>
            <div
              className="absolute bottom-0 left-1/2 -translate-x-1/2 rounded-full flex flex-col items-center pt-[9%]"
              style={{ width: 230, height: 230, background: "rgba(129, 140, 248, 0.6)", zIndex: 2 }}
            >
              <span className="text-[11px] opacity-90 mb-1 text-white">Legal Services</span>
              <span className="text-[20px] font-medium text-white font-[family-name:var(--font-heading)]">£1.1T</span>
            </div>
            <div
              className="absolute bottom-0 left-1/2 -translate-x-1/2 rounded-full flex flex-col items-center justify-center"
              style={{ width: 140, height: 140, background: "rgba(99, 102, 241, 0.9)", zIndex: 3 }}
            >
              <span className="text-[10px] opacity-90 mb-0.5 text-white">Immigration</span>
              <span className="text-[16px] font-medium text-white font-[family-name:var(--font-heading)]">£24.4B</span>
            </div>
          </div>
        </div>
      </div>

      <div className="text-left mt-auto mb-8 pb-4 border-b border-[var(--color-border)]">
        <p className="text-[12px] text-[var(--color-fg-secondary)] font-light">
          The playbook is the same. The data compounds. <strong className="font-medium text-[var(--color-fg)]">Each vertical makes the next one easier.</strong>
        </p>
      </div>
    </div>
  );
}
